


import { useState } from "react";
import Config from "../../Config";

 

import Wall from "./Wall";
import WallSettings from "../news/WallSettings";

import EatM from "./EatM";
import Eat from "./Eat";

import Topic from "./Topic";
import PlanR from "./PlanR";
import CalendarYearE from "./CalendarYearE";
import CalendarYearEM from "./CalendarYearEM";
import Query from "./Query";
 

import CalendarYear from "./CalendarYear";


function NewsView(props)
{
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }


    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
    var tab5 = " m_item ";
    var tab6 = " m_item ";



    if(props.mainView.viewSelected == "wall" || props.mainView.viewSelected == "view") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "eat") tab2 = tab2 + " selected";
    //if(props.mainView.viewSelected == "topic") tab3 = tab3 + " selected";
    //if(props.mainView.viewSelected == "plan") tab4 = tab4 + " selected";
    if(props.mainView.viewSelected == "calendar") tab5 = tab5 + " selected";
    //if(props.mainView.viewSelected == "query") tab6 = tab6 + " selected";

    //            <div className={tab4}  module="news" view="plan" id="" onClick={props.mainView.quickGo} >Plan dnia</div>
    //<div className={tab3}  module="news" view="topic" id="" onClick={props.mainView.quickGo} >Tematy zajęć</div>        
    <div className={tab6}  module="news" view="query" id="" onClick={props.mainView.quickGo} >Ankiety i pytania</div>        

    var subMenu = <div className="submenu">
            <div className={tab1} module="newse" view="wall" id="" onClick={props.mainView.quickGo} >Posty</div>
            <div className={tab2} module="newse" view="eat" id="" onClick={props.mainView.quickGo} >Jadłospis</div>
            <div className={tab5}  module="newse" view="calendar" id="" onClick={props.mainView.quickGo} >Kalendarz</div>
            
    </div>
 
 

    if(props.mainView.viewSelected == 'wall' || props.mainView.viewSelected == 'viewe')
    {
        document.title ="Posty / Aktualności"; 

        return (
            <div>                           
           
                   {subMenu} 
                  <Wall  userData={props.userData}  mainView={props.mainView}  />
             </div>
        )
    }

    var is_mobile = props.mainView.isMobile();

    if(props.mainView.viewSelected == 'eat')
    {   
        document.title ="Jadłospis / Aktualności"; 

        if(is_mobile)
        {
            return (
                <div >    
                     {subMenu}  
                     <EatM  userData={props.userData}  mainView={props.mainView}  />
                </div>
            )
        }
        else{
            return (
                <div>    
                     {subMenu}  
                     <Eat  userData={props.userData}  mainView={props.mainView}  />
                </div>
            )
        }
        
        
    }

 

        if(props.mainView.viewSelected == 'calendar')
            {
                document.title ="Kalendarz"; 
               
                
                if(is_mobile)
                {
                    return (
                        <div >    
                            {subMenu} 
                             <CalendarYear  userData={props.userData}  mainView={props.mainView}  />
                        </div>
                        )
                }
                else
                {
                    return (
                        <div>    
                            {subMenu} 
                             <CalendarYear  userData={props.userData}  mainView={props.mainView}  />
                        </div>
                        )
                }
            }




            /*
            if(props.mainView.viewSelected == 'query')
                {
                    document.title ="Ankiety i pytania"; 
                    return (
                        <div className="econtent ">    
                              {subMenu} 
                              <Query  userData={props.userData}  mainView={props.mainView}  />
                        </div>
                    )
                }
            */    
                

    return (
        <div className="econtent ">
             {props.mainView.viewSelected}
        </div>
    );
}

export default NewsView;